import script from "./EditorHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorHeader.vue?vue&type=script&setup=true&lang=ts"

import "./EditorHeader.vue?vue&type=style&index=0&id=4bca4cac&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bca4cac"]])

export default __exports__